jQuery(document).ready(function ($) {

    if ( typeof affcoups_vars !== 'undefined' ) {


        // Quit if store is not known
        if ( affcoups_vars.hasOwnProperty('event_tracking') ) {
            console.log('event_tracking activated');

            $('[data-affcoups-event-tracking="true"] a, a[data-affcoups-event-tracking="true"]').on( "click", function( event ) {

                // Debug
                //event.preventDefault();

                var link = $( this );

                // If clicked link has container attribute take it, otherwise search for the ancestor
                var container = ( $( this ).attr('data-affcoups-coupon-id') ) ? $( this ) : $( this ).closest( '[data-affcoups-coupon-id]' );

                var label = false;

                if ( typeof container.data('affcoups-coupon-title') !== 'undefined' ) {
                    label = container.data('affcoups-coupon-title');
                }

                console.log('event_tracking >> label: ' + label );

                if ( ! label )
                    return;

                var category = 'affiliate-coupon-link';
                var action = 'click';

                // Google Tag Manager
                if (typeof dataLayer !== "undefined") {
                    console.log( 'Google Tag Manager' );
                    dataLayer.push({
                        'event': category + '-click',
                        'category': category,
                        'action': action,
                        'label': label
                    });

                // Google Analytics new
                } else if ( typeof gtag === "function" ) {
                    console.log('Google Analytics new');
                    gtag('event', action, {
                        'event_category': category,
                        'event_label': label
                    });

                // Google Analytics
                } else if (typeof (ga) !== "undefined") {
                    console.log('Google Analytics');
                    ga('send', 'event', category, action, label, 'beacon');

                // Google Analytics (old)
                } else if (typeof (_gaq) !== "undefined") {
                    console.log( 'Google Analytics old' );
                    _gaq.push(['_trackEvent', category, action, label]);

                // Google Analytics (Yoast)
                } else if (typeof (__gaTracker) !== "undefined") {
                    console.log( 'Google Analytics (Yoast)' );
                    __gaTracker('send', 'event', category, action, label);

                // Piwik (Matomo)
                } else if (typeof (_paq) !== "undefined") {
                    console.log( 'Piwik (Matomo)' );
                    _paq.push(['trackEvent', category, action, label]);
                }

            });
        }
    }

});